












































import { importKnowledgeLibrary } from '@/api/api'
/* import { downloadFile } from '@/utils/index' */

export default ({
  props: {
    visible:{
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileList: [],
      loading:  {
        submit: false
        //download: false
      },
    }
  },
  methods: {
    /* download() {
      exportMaintainItemTemplate().then(res =>{
        // 创建隐藏的可下载链接
        var a = document.createElement('a')
        a.download = `${this.$t('page_plan_maintenance_items')}.xlsx`
        a.style.display = 'none'
        // 字符内容转变成blob地址
        // var blob = new Blob([res])
        let url = URL.createObjectURL(res)
        a.href = url
        // 触发点击
        document.body.appendChild(a)
        a.click()
        // 然后移除
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })
    }, */
    handleCancel() {
      this.fileList = []
      this.$emit('closeImport',false)
    },
    beforeUpload(file: any) {
      const isGt20M = file.size / 1024 / 1024 > 20
      if (isGt20M) {
        this.$message.error(this.$t('page_my_document_notsupport'));
        return false
      }
      this.fileList = [file]
      return false
    },
    handleOk() {
      if(!this.fileList.length) {
        this.$message.warning(this.$t('page_my_document_select'))
        return
      }
      const formData = new FormData()
      formData.append('file', this.fileList[0])
      if(this.loading.submit){return}
      this.loading.submit = true
      importKnowledgeLibrary(formData).then(res => {
        this.$message.success(this.$t('page_material_check_success_tip'))
        this.fileList = []
        this.$emit('closeImport',true)
      }).finally(()=>{
        this.loading.submit = false
        this.fileList = []
        this.$emit('closeImport',true)
      })
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    }
  }
})
